import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCategoryBySlug } from 'api/strapi';

function gearId(item, index, categorySlug) {
  const prefix = (categorySlug || 'EQP').slice(0, 3).toUpperCase();
  return `${prefix}-${String(index + 1).padStart(3, '0')}`;
}

function CategoryDetail() {
  const { t } = useTranslation();
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setError(null);
    setCategory(null);

    getCategoryBySlug(slug)
      .then((response) => {
        if (!cancelled) {
          setCategory(response.data?.[0] || null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) {
    return <p className="status-message container">{t('states.loadingCategory')}</p>;
  }

  if (error) {
    return (
      <p className="status-message status-message--error container">
        {t('states.loadCategoryError', { error })}
      </p>
    );
  }

  if (!category) {
    return (
      <div className="container category-detail">
        <p className="status-message">{t('states.categoryNotFound')}</p>
        <Link to="/" className="category-detail__back">{t('catalog.backToCategories')}</Link>
      </div>
    );
  }

  const equipment = category.equipment || [];

  return (
    <div className="container category-detail">
      <div className="category-detail__header">
        <h1 className="category-detail__title">{category.name}</h1>
        {category.description && (
          <p className="category-detail__description">{category.description}</p>
        )}
      </div>

      {equipment.length === 0 ? (
        <p className="status-message">{t('states.noEquipment')}</p>
      ) : (
        <div className="gear-grid">
          {equipment.map((item, index) => (
            <div className="gear-card" key={item.documentId || item.id}>
              <span className="gear-id">{gearId(item, index, category.slug)}</span>
              <div className="gear-name">{item.name}</div>
              <div className="gear-category">{category.name}</div>
              {item.dailyRate != null && (
                <div className="gear-price">{t('catalog.plnPerDay', { rate: item.dailyRate })}</div>
              )}
              {item.description && (
                <p className="cat-desc">{item.description}</p>
              )}
              <div className="gear-status">
                <span className="dot-avail">{t('catalog.available')}</span>
                <a href="mailto:mikolaj.bonowski@gmail.com" className="reserve-link">
                  {t('catalog.reserve')}
                </a>
              </div>
            </div>
          ))}
        </div>
      )}

      <Link to="/#categories" className="category-detail__back">{t('catalog.backToCategories')}</Link>
    </div>
  );
}

export default CategoryDetail;
